import ImageButton from "./ImageButton";
import styled from "styled-components";
const CloseCircle = styled(ImageButton)`
  width: 30px;
  height: 30px;
  position: absolute;
  top: 1%;
  right: 0;
  margin-right: 10px;
  margin-top: 10px;
  z-index: 1;
`;
export default CloseCircle;